import React from "react";

export const formSubmitMapper = (data) => ({
  id_purchase_order: data.id_purchase_order,
  tgl_close_purchase_order: data.tgl_close_purchase_order,
});
